export default __webpack_public_path__ + "static/media/flag-japan.582e8c78.svg";